/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LocalTimeLocalTimeTuple
 */
export interface LocalTimeLocalTimeTuple {
    /**
     * 
     * @type {object}
     * @memberof LocalTimeLocalTimeTuple
     */
    item1?: object;
    /**
     * 
     * @type {object}
     * @memberof LocalTimeLocalTimeTuple
     */
    item2?: object;
}

export function LocalTimeLocalTimeTupleFromJSON(json: any): LocalTimeLocalTimeTuple {
    return LocalTimeLocalTimeTupleFromJSONTyped(json, false);
}

export function LocalTimeLocalTimeTupleFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocalTimeLocalTimeTuple {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'item1': !exists(json, 'item1') ? undefined : json['item1'],
        'item2': !exists(json, 'item2') ? undefined : json['item2'],
    };
}

export function LocalTimeLocalTimeTupleToJSON(value?: LocalTimeLocalTimeTuple | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item1': value.item1,
        'item2': value.item2,
    };
}


